import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import API from "@beardeddevops/react.api";
import moment from "moment";
import PriorityHigh from "@material-ui/icons/PriorityHigh";
import {Button, ButtonGroup, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import APPCONFIG from "../../constants/Config";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import TextField from "@material-ui/core/TextField";
import {confirmAlert} from "react-confirm-alert";


class TimeOffRequest extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Time_Off._name);
		this.state.disabled = false;
		if (!Array.isArray(this.state.time_slots) && typeof this.state.time_slots !== 'string') {
			this.state.time_slots = [];
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (!this.state.pkey && (prevState.requested_date_start !== this.state.requested_date_start || prevState.requested_date_end !== this.state.requested_date_end)) {
			if (moment(this.state.requested_date_start).isAfter(moment(this.state.requested_date_end))) {
				alert("Start Date must be earlier than End Date.");
				this.setState({requested_date_start: prevState.requested_date_start, requested_date_end: prevState.requested_date_end});
			} else if (moment(this.state.requested_date_start).add(12, 'hours').isBefore(moment()) && moment(this.state.requested_date_start).format('YYYY-MM-DD') !== moment().format('YYYY-MM-DD')) {
				alert("Cannot request for past dates.")
				this.setState({requested_date_start: prevState.requested_date_start, requested_date_end: prevState.requested_date_end});
			}
		}
		if (moment(this.state.requested_date_start).format('YYYY-MM-DD') !== moment(this.state.requested_date_end).format('YYYY-MM-DD') && this.state.requested_date_start && this.state.requested_date_end && !this.state.full_day) {
			this.setState({full_day: true})
		}
		if (this.state.disabled !== ((this.state.creator !== this.props.user) || this.state.status != 1) && this.state.pkey) {
			this.setState({
				disabled: ((this.state.creator !== this.props.user) || this.state.status != 1)
			})
		}
		if (this.state.canSelfApprove !== ((this.state.creator === this.props.user) && this.props.main_role <= 21)) {
			this.setState({canSelfApprove: ((this.state.creator === this.props.user) && this.props.main_role <= 21)})
		}
		if (this.state.disabled === true && !this.state.pkey) {
			this.setState({disabled: false})
		}
	}

	handleSubmit = async (event) => {
		if ([1, 4].includes(this.state.reason) && !this.state.image) {
			alert('You must provide an image for this reason.')
			return;
		}
		const main_role = this.props.main_role ?? this.props.rootState?.main_role;
		if (!this.state.full_day && Number(main_role) === 40) {
			const slots = Array.isArray(this.state.time_slots)
				? this.state.time_slots
				: (typeof this.state.time_slots === 'string' && this.state.time_slots
					? this.state.time_slots.split(',').filter(Boolean)
					: []);
			if (slots.length === 0) {
				alert('Select at least one time slot for a partial day schedule adjustment.');
				return;
			}
			this.state.full_day_am_pm = null;
		}
		this.state.time_slots = this.state.time_slots ? typeof (this.state.time_slots) === 'string' ? this.state.time_slots : this.state.time_slots.join(',') : ''
		super.handleSubmit(event);
	}

	handleTimeSlotSelect = async (event) => {
		let _timeSlots = Array.isArray(this.state.time_slots)
			? [...this.state.time_slots]
			: (typeof this.state.time_slots === 'string' && this.state.time_slots
				? this.state.time_slots.split(',').filter(Boolean)
				: []);
		if (_timeSlots.includes(event.currentTarget.id)) {
			_timeSlots.splice(_timeSlots.indexOf(event.currentTarget.id), 1);
			await this.setState({time_slots: _timeSlots, full_day_am_pm: false});
		} else {
			await this.setState({time_slots: [..._timeSlots, event.currentTarget.id], full_day_am_pm: false});
		}
	}

	handleStatusChange = (event) => {
		const type = event.currentTarget.id;
		confirmAlert({
			title: (`Confirm Request ${type === 'approve' ? 'Approval' : 'Denial'}`),
			message: `Are you sure you want to ${type} this schedule adjustment?`,
			buttons: [
				{
					label: 'Yes',
					color: 'danger',
					onClick: async () => {
						let approveModel = new API.BuildClass(Types.Time_Off._name, API.RequestType.UPDATE);
						this.state.status = type === 'approve' ? 2 : 3;
						try {
							await approveModel.submit(this, "POST_APPROVAL");
							this.props.history.goBack()
						} catch (error) {
						}
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}

	handleDenial = () => {
		confirmAlert({
			title: ('Your Request Was Denied'),
			message: 'This schedule adjustment was denied. Please select an option below. You can either accept this denial and work as normal, or reject the denial and accept an unapproved absence.',
			buttons: [
				{
					label: 'Reject Denial (WILL NOT SHOW UP)',
					color: 'danger',
					onClick: async () => {
						this.state.status = 4;
						let approveModel = new API.BuildClass(Types.Time_Off._name, API.RequestType.UPDATE);
						try {
							await approveModel.submit(this, "POST");
							this.props.history.goBack()
						} catch (error) {
						}
					}
				},
				{
					label: 'Accept Denial (WILL SHOW UP)',
					onClick: async () => {
						this.state.status = 5;
						let approveModel = new API.BuildClass(Types.Time_Off._name, API.RequestType.UPDATE);
						try {
							await approveModel.submit(this, "POST");
							this.props.history.goBack()
						} catch (error) {
						}
					}
				}
			]
		});
	}

	render() {
		/**
		 * @param {Time_Off_Properties} properties
		 */
		let {properties} = this.model
		/**
		 * @type {Time_Off_Object} object
		 */
		let object = this.state
		let {loading, disabled, canSelfApprove} = this.state;

		const {fe_work_order_amount} = this.props.rootState;

		const main_role = this.props.main_role ?? this.props.rootState?.main_role;
		const showFeTimeSlots = Number(main_role) === 40
			|| (typeof object.time_slots === 'string' && object.time_slots.length > 0);

		const timeSlotsForUi = Array.isArray(this.state.time_slots)
			? this.state.time_slots
			: (typeof this.state.time_slots === 'string' && this.state.time_slots
				? this.state.time_slots.split(',').filter(Boolean)
				: []);

		const _time_slots = fe_work_order_amount === 5 ? ["8AM-10AM", "9AM-12PM", "12PM-3PM", "2PM-5PM", "4PM-7PM"] : ["8AM-10AM", "9AM-12PM", "12PM-3PM", "2PM-5PM"];

		this.noDelete = object.pkey && (!disabled || (this.state.creator === this.props.user));

		return (
			<Card style={{overflow: 'visible'}} key={disabled}>
				<CardContent style={{paddingBottom: 0}}>
					<div>
						<div className="form-group" style={{display: 'flex', flexDirection: 'column', gap: 5}}>
							{!object.pkey &&
								<b style={{textAlign: 'center', paddingBottom: 5}}>Schedule Adjustments that span more than one day default to full day, if you
									need
									multiple
									days of half/special schedule please submit one schedule adjust per day.</b>}
							<div className={'row d-flex'}>
								<div className={`col-${object.pkey ? 3 : 6}`}>
									<div className="form-group">
										<Framework.Elements.Date
											label="Start Date"
											property={properties.requested_date_start}
											value={object.requested_date_start}
											error={object.requested_date_start_error}
											update={this.handleTextFieldPropertyUpdate}
											disabled={disabled || object.pkey}
										/>
									</div>
								</div>
								<div className={`col-${object.pkey ? 3 : 6}`}>
									<div className="form-group">
										<Framework.Elements.Date
											label="End Date"
											property={properties.requested_date_end}
											value={object.requested_date_end}
											error={object.requested_date_end_error}
											update={this.handleTextFieldPropertyUpdate}
											disabled={disabled || object.pkey}
										/>
									</div>
								</div>
								{object.pkey && <div className="col-4">
									<div className="form-group">
										<TextField
											value={object.requested_by}
											label={'Request For'}
											disabled={true}
											fullWidth={true}
											margin={'dense'}
											variant={'outlined'}
										/>
									</div>
								</div>}
								{object.pkey && <div className="col-2">
									<div className="form-group">
										<TextField
											key={object.time_off_status.status}
											value={object.time_off_status.status}
											label={'Current Status'}
											disabled={true}
											fullWidth={true}
											margin={'dense'}
											variant={'outlined'}
										/>
									</div>
								</div>}
							</div>

							<div className={'row d-flex'}>
								<div className={'col-sm-12 col-md-3 col-lg-6'}>
									<div className="form-group">
										<Framework.Elements.Select
											shouldLoad={this.state.loaded}
											label={"Reason for Change"}
											property={properties.reason}
											value={object.reason}
											error={object.reason_error}
											object={object.time_off_reasons}
											update={this.handleSelectPropertyUpdate}
											nullable={true}
											disabled={disabled}
										/>
									</div>
								</div>

								{object.freshdesk && <div className={'col-sm-12 col-md-9 col-lg-6'}>
									<a href={"https://karlstechnology.freshdesk.com/helpdesk/tickets/" + object.freshdesk} target={"_blank"}>
										<div className="form-group">
											<Framework.Elements.TextField
												label={"Freshdesk Ticket"}
												value={object.freshdesk ? `https://karlstechnology.freshdesk.com/a/tickets/${object.freshdesk}` : ''}
												error={object.freshdesk_error}
												disabled={true}
											/>
										</div>
									</a>
								</div>}
							</div>

							<div className={'row d-flex'}>
								<div className={'col-12'}>
									<div className={'form-group'}>
										<ButtonGroup>
											<Button
												onClick={() => {
													this.setState({full_day: true, time_slots: '', full_day_am_pm: false});
												}}
												outline={!this.state.full_day}
												active={this.state.full_day}
												color={'info'}
												disabled={disabled || object.pkey}
											>
												Full Day
											</Button>
											<Button
												onClick={() => {
													this.setState({
														full_day: false,
														time_slots: Number(main_role) === 40 ? [] : this.state.time_slots,
														full_day_am_pm: Number(main_role) === 40 ? null : this.state.full_day_am_pm,
													});
												}}
												outline={this.state.full_day}
												active={!this.state.full_day}
												color={'info'}
												disabled={disabled || object.pkey}
											>
												Partial Day
											</Button>
										</ButtonGroup>
									</div>
								</div>
							</div>

							<div className={'row d-flex'}>
								{!object.full_day && <div className={'col-12'}>
									<div className="form-group" key={main_role}>
										{showFeTimeSlots ? <ButtonGroup>
											{_time_slots.map((slot) => <Button
												id={slot}
												onClick={this.handleTimeSlotSelect}
												outline={!timeSlotsForUi.includes(slot)}
												active={timeSlotsForUi.includes(slot)}
												color={'primary'}
												disabled={disabled || object.pkey}
											>
												{slot.replace('-', ' - ')}
											</Button>)}

										</ButtonGroup> : <ButtonGroup>
											<Button
												onClick={() => {
													this.setState({full_day_am_pm: true, time_slots: ''});
												}}
												outline={!this.state.full_day_am_pm}
												active={this.state.full_day_am_pm}
												color={'info'}
												disabled={disabled || object.pkey}
											>
												Off AM
											</Button>
											<Button
												onClick={() => {
													this.setState({full_day_am_pm: false, time_slots: ''});
												}}
												outline={this.state.full_day_am_pm}
												active={!this.state.full_day_am_pm}
												color={'info'}
												disabled={disabled || object.pkey}
											>
												Off PM
											</Button>
										</ButtonGroup>}
									</div>
								</div>}
							</div>

							<div className={'row d-flex'}>
								<div className={'col-12'}>
									<Framework.Elements.TextField
										property={properties.notes}
										value={object.notes}
										error={object.notes_error}
										update={this.handleTextFieldPropertyUpdate}
										label={'Notes'}
										multiline={4}
										disabled={disabled && main_role !== 21}
									/>
								</div>
							</div>

							<div className={'row d-flex'} style={{gap: 5}}>
								<div className={'col-12'} style={{display: 'grid'}}>
									{object.image && <img
										src={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/time_off/' + '/images?image=' + object.image}
										alt={object.image}
										style={{maxWidth: '100%', justifySelf: 'center'}}
									/>}
								</div>
								<div className={'col-12'} style={{paddingBottom: 15}}>
									<Framework.Elements.DropZone
										property={properties.image}
										value={object.image}
										error={object.image_error}
										multiple={false}
										update={this.handleFileChange}
										label={'Click to select image.'}
									/>
								</div>
							</div>
						</div>

						<Framework.Elements.LoadingSpinner isLoading={loading}/>
					</div>
				</CardContent>
				{object.pkey && <CardActions style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					padding: '14px'
				}}>
					<Button color="secondary" onClick={() => this.props.history.goBack()}>Back</Button>

					<div style={{
						display: 'flex',
						alignItems: 'center',
						gap: '5px'
					}}>
						{((main_role === 21 || canSelfApprove) && object.status !== 2) &&
							<Button id={'approve'} color="info" onClick={this.handleStatusChange}>Approve</Button>}
						{((main_role === 21 || canSelfApprove) && object.status !== 3) &&
							<Button id={'deny'} color="danger" onClick={this.handleStatusChange}>Deny</Button>}
						{this.noDelete && (
							<Button color="danger" onClick={this.handleDelete}>Delete</Button>
						)}
						{((!disabled || object.image) || main_role === 21) && (
							<Button color="primary" onClick={this.handleSubmit}>Save</Button>
						)}
						{((!disabled || (this.state.creator === this.props.user)) && object.status === 3) && (
							<Button color="primary" onClick={this.handleDenial}>Acknowledge Denial</Button>
						)}
					</div>
				</CardActions>}

			</Card>


		)
	}
}

export default Framework.Components.withRootState(TimeOffRequest)